import { BaseElement } from "./baseElement";
import {Box} from "../layout/box.ts";
import type {jsPDF} from "jspdf";

export class Svg extends BaseElement {
	kind = "svg" as const;
	svg: HTMLCanvasElement;

	constructor(box: Box, id: string, svg: HTMLCanvasElement) {
		super(box, id);
		this.svg = svg;
	}

	async draw(pdfDocument: jsPDF): Promise<void> {
		const box = this.box.getBoundingBox();
		pdfDocument.addImage(this.svg, "PNG", box.x, box.y, box.width, box.height);
	}
}
